<template>
<a-row>
    <a-modal 
        v-if="uploadPanel" 
        v-model="uploadPanel" 
        title="批量标记数据" 
        :footer="null" 
        width="800px" 
        style="top: 49px;">
        <upload :pfxtag="tag"/>
    </a-modal>
    <a-col :span="24" class="mb12">
        <a-textarea
            v-model="tagText" 
            rows="16" 
            placeholder="请输入标签, 每行一个标签，用缩进表示层次关系" 
            style="padding: 8px;"
        />
    </a-col>
    <!-- a-col :span="24" class="mb12">
        <a-button type="primary" @click="saveTags">保存</a-button>
    </a-col-->
    <a-col :span="24" class="mb12">
        <a-button type="primary" @click="changeText2Tree">转换</a-button>
    </a-col>
    <a-col :span="24" class="mb12">
        <a-row>
            <a-col :span="24" v-for="(item, index) in trees" :key="index">
                <table-tree 
                    v-if="item && item.title && item.title.length" 
                    :tree="item" 
                    :index="index" 
                    :id="item.id" 
                    @selectedtag="showUpload" 
                    @change="autoSave"
                />
            </a-col>
        </a-row>
    </a-col>
</a-row>
</template>

<script>

import TableTree from '@/com/Tree/TableTree.js'
import Upload from './Upload.vue'

function node(lbl, lvl)
{
    var sub = [],
    parent = null;

    return {
        title: lbl,
        value: lbl,
        key: lbl,
        children : sub,

        lvl:()=>lvl==undefined?-1:lvl,
        parent:()=>parent, //as a function to prevent circular reference when parse to JSON
        setParent:p=>{parent=p},
        appendChildren: function(c){
            sub.push(c); 
            c.setParent(this);
            if (this.value != "")
            { 
              c.value = this.value + "/" + c.value;
              c.key = c.value;
            }
            return this; 
        },
    }
}

function appendLine(prev, curr) 
{
    if(typeof(curr)=='string')
    {   //in the recursive call it's a object
        curr = curr.trimRight().replace("\t", "        "); 
        if (curr.length > 0)
        {
            curr = curr.split(/ /);
            curr = node(curr.pop(), curr.length);
        }
        else
            return prev; //empty lines are skipped  
    }

    if(curr.lvl() > prev.lvl())
    {   //curr is prev's child
        prev.appendChildren(curr);
    }
    else 
    if(curr.lvl() < prev.lvl())
    {   //recursive call to find the right parent level
        appendLine(prev.parent(), curr) 
    }
    else
    {   //curr is prev's sibling
        prev.parent().appendChildren(curr);
    }

    return curr;
}

function indentedText2JSON(text) 
{
    var result = node('');
    if (!text || text.length == 0)
    return result; 

    text.toString().split('\n').reduce(appendLine, result); 

    //console.log(JSON.stringify(result));
    return result.children; 
}

export default {

    name: 'tagset',

    data() 
    {
        return {
            uploadPanel: false,
            tag: "",
            tab: "uc,tag",
            title: "标签定制",
            tagText: "",
            tagArray: [],
            trees: []
        }
    },

    components: 
    {
        TableTree,
        Upload
    },

    methods: 
    {
        showUpload: function(selectedtag) 
        {
            this.tag = selectedtag;
            this.uploadPanel = true
        },

        autoSave: function(item, index, id) 
        {
            console.log("In autoSave:") 
            console.log(item); 
            console.log(index); 
            console.log(id); 
            
            var share = item.share; 

            item.share = undefined; 

            let postdata = {
                task: "UPDATE_TREE_TAGS",
                tree: item,
                id: id
            }

            let that = this;
            that.post("profile", postdata)
                .then(function(data) 
                {
                    if (data.ret == 200) 
                    {
                        if (that.trees[index] != null) 
                        {
                            that.$set(that.trees[index], "id", data.data.id);
                        }
                    }

                    item.share = share;
                }).catch(function (e) 
                {
                  console.log(e);
                  that.$message.error("失败");
                  item.share = share;
                })
        },

        changeText2Tree: function() 
        {
            let trees = indentedText2JSON(this.tagText);
            for (let i = 0; i < trees.length; i++) 
            {
                let tree = trees[i];
                tree["id"] = "";
                this.trees.unshift([tree]);
                let postdata = {
                  task: "UPDATE_TREE_TAGS",
                  tree: tree,
                  id: ""
                }
                let that = this;
                that.post("profile", postdata)
                  .then(function(data) 
                  {
                      if (data.ret == 200) 
                      {
                          that.$set(that.trees[0], "id", data.data.id);
                      }
                  }).catch(function (e) 
                  {
                    console.log(e);
                    that.$message.error("失败");
                  })
            }
        },

        saveTags: function() 
        {
            let tags = this.tagText.split("\n");
            let usertags = [];
            for(let i = 0; i < tags.length; i++) 
            {
                if (tags[i].trim() != "") 
                {
                    usertags.push(tags[i].trim());
                }
            }
            if (usertags.length == 0) 
            {
                return;
            }
            let postdata = {
              task: "ADD_USER_TAGS",
              tags: usertags
            };
            let that = this;
            that.post("profile", postdata)
                .then(function(data) 
                {
                  if (data.ret == 200) 
                  {
                      usertags = data.data;
                      for (let i = 0; i < usertags.length; i++) 
                      {
                          let skip = false; 
                          for (let j = 0; j < that.tagArray.length; j++)
                              if (that.tagArray[j].tags == usertags[i].tags)
                              { 
                                  skip = true; 
                                  break; 
                              }
                          if (skip) continue; 
                          that.tagArray.push({ id : usertags[i].id, tags: usertags[i].tags }); 
                          that.tagText = "";
                      }
                  } 
                  else 
                  {
                      that.$message.error("添加失败");
                  }
                }).catch(function (e) 
                {
                    console.log(e);
                    that.$message.error("添加失败");
                })
        }
    },

    created() 
    {
        this.$store.commit('changetab', this.tab)
        let postdata = {
          task: "SEARCH_TREE_TAGS",
          type: "ent",
          stats: true
        }
        let that = this
        that.post('profile', postdata)
          .then(function(data) 
          {
              if (data.ret == 200) 
              {
                  //that.tagArray = data.data
                  that.trees = data.data;
                  console.log("in Tabset"); 
                  console.log(that.trees); 
              }
          }).catch(function (e) 
          {
              console.log(e)
          });
    }
}
</script>

<style scoped>

    .mb12 {
      margin-bottom: 12px;
      text-align: left;
    }

</style>
